export const GA_MEASUREMENT_ID = "G-JRFDX6E5VH";

const CONSENT_KEY = "tchAnalyticsConsent";
const CONSENT_EVENT = "tch:analytics-consent";

export const getAnalyticsConsent = () => {
  try {
    const consent = window.localStorage.getItem(CONSENT_KEY);

    if (consent === "granted" || consent === "denied") {
      return consent;
    }

    // Migrate the legacy consent values used by the previous banner.
    if (window.localStorage.getItem("cookiesRejected") === "true") {
      return "denied";
    }

    if (window.localStorage.getItem("cookiesAccepted") === "true") {
      return "granted";
    }
  } catch {
    return null;
  }

  return null;
};

export const saveAnalyticsConsent = (consent) => {
  try {
    window.localStorage.setItem(CONSENT_KEY, consent);
    window.localStorage.removeItem("cookiesAccepted");
    window.localStorage.removeItem("cookiesRejected");
  } catch {
    // Browsers that block storage still receive the choice for this page view.
  }

  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: consent }));
};

export const subscribeToAnalyticsConsent = (listener) => {
  const handleConsent = (event) => listener(event.detail);
  window.addEventListener(CONSENT_EVENT, handleConsent);

  return () => window.removeEventListener(CONSENT_EVENT, handleConsent);
};

export const enableGoogleAnalytics = () => {
  window[`ga-disable-${GA_MEASUREMENT_ID}`] = false;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag("consent", "update", {
    analytics_storage: "granted",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });

  if (!document.querySelector(`script[data-ga4-id="${GA_MEASUREMENT_ID}"]`)) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.dataset.ga4Id = GA_MEASUREMENT_ID;
    document.head.appendChild(script);

    window.gtag("js", new Date());
    window.gtag("config", GA_MEASUREMENT_ID, {
      send_page_view: false,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
    });
  }
};

export const disableGoogleAnalytics = () => {
  window[`ga-disable-${GA_MEASUREMENT_ID}`] = true;

  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
  }
};

export const trackPageView = (pathname) => {
  if (typeof window.gtag !== "function") {
    return;
  }

  window.gtag("event", "page_view", {
    page_path: pathname,
    page_location: `${window.location.origin}${pathname}`,
    page_title: document.title,
  });
};
